export const powerBiConfig = {
    // Use an environment variable if set, otherwise fallback to the default value.
    id: process.env.REACT_APP_POWER_BI_ID || "cf11d1b9-b2a5-40ab-9d70-c71116778295"
};

export const apiMainUrl = process.env.REACT_APP_API_MAIN_URL || "https://localhost:7106/api/";
export const keyMainUrl = process.env.REACT_APP_KEY_MAIN_URL || 'https://dmkey.azurewebsites.net/api/';
export const blobStorageSAS = process.env.REACT_APP_BLOB_SAS; // No default here, ensure it’s set in production